export default __webpack_public_path__ + "static/media/TearsJoy2.651adaaa.svg";